import { logStart } from './base';
let count = 0;
export default function callNative(name, { params, isPromise = true, timeout = 2000, module = 'Kwaiying', ignoreErrorReport, } = {}) {
    const report = logStart(isPromise, module, name, ignoreErrorReport);
    if (!window.kwaiying || !window.kwaiying[name]) {
        return report.fail(new Error(`method: ${name} not found`));
    }
    if (!isPromise) {
        // window.kwaiying['closePage'](undefined) 会报错，没有参数不能瞎传
        try {
            params
                ? window.kwaiying[name](JSON.stringify(params))
                : window.kwaiying[name]();
            report.success();
        }
        catch (err) {
            report.fail(err, false, params);
        }
    }
    else {
        return new Promise((resolve, reject) => {
            const callbackName = `__bridge__${count++}__`;
            let isPending = true;
            params = params || {};
            // @ts-expect-error
            params.callback = callbackName;
            // @ts-expect-error
            window[callbackName] = (data) => {
                isPending = false;
                let result = data && data.result ? data.result : data;
                resolve(result);
                report.success();
                // @ts-expect-error
                delete window[callbackName];
            };
            window.kwaiying[name](JSON.stringify(params));
            timeout &&
                setTimeout((err) => {
                    reject(err);
                    isPending && report.fail(err);
                }, timeout, new Error('timeout'));
        });
    }
}
